import {
  FETCH_SUPPORT_CATEGORIES,
  FETCH_SUPPORT_CATEGORIES_SUCCESS,
  FETCH_SUPPORT_CATEGORIES_FAILED,
  EDIT_SUPPORT_CATEGORY
} from "../store/types";

const INITIAL_STATE = {
  supportCategories: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const supportcategoryreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SUPPORT_CATEGORIES:
      return {
        ...state,
        loading: true
      };
    case FETCH_SUPPORT_CATEGORIES_SUCCESS:
      return {
        ...state,
        supportCategories: action.payload,
        loading: false
      };
    case FETCH_SUPPORT_CATEGORIES_FAILED:
      return {
        ...state,
        supportCategories: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_SUPPORT_CATEGORY:
      return state;
    default:
      return state;
  }
} 